import React from "react";
import { OverlayTrigger, Glyphicon, Popover } from "react-bootstrap";

export const TooltipWithText = ({ children, id }) => {
  const popoverRight = <Popover id={id}>{children}</Popover>;
  return (
    <div
      className="custom-tooltip"
      style={{ display: children ? "flex" : "none" }}
    >
      <OverlayTrigger overlay={popoverRight} placement="right" rootClose>
        <span>
          <Glyphicon glyph="info-sign" />
        </span>
      </OverlayTrigger>
    </div>
  );
};
